import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useModuleIds, useUserProjectRole } from 'portal/lib/hooks'
import { readingsLoad } from 'portal/store/utilities/readings/actions'

export const useReadingsLoader = () => {
  const dispatch = useDispatch()
  const { accountId, projectId } = useModuleIds()

  const { isReadOnly } = useUserProjectRole(accountId, projectId)

  const reload = useCallback(() => {
    if (!accountId || !projectId) {
      return
    }
    dispatch(readingsLoad(accountId, projectId))
  }, [dispatch, accountId, projectId])

  useEffect(() => {
    reload()
  }, [reload])

  const { loading, error, items } = useSelector((state: any) => {
    return state.readings
  })

  return {
    loading,
    error,
    items,
    reload,
    readOnly: isReadOnly
  }
}
